import React, { Component } from 'react';
import Routes from './routes';
import { createStore, applyMiddleware } from 'redux';
import {thunk} from 'redux-thunk';
import combineReducers from './configuration/combineReducer';
import { Provider } from 'react-redux';
import { configureAxiosDefaults, axiosResponse } from './api/axios';
import ReduxToastr from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';

class App extends Component {
	render() {
		const appStore = createStore(
      combineReducers,
      {},
      applyMiddleware(thunk)
    );
    configureAxiosDefaults();
    axiosResponse();
		return (
      <Provider store={appStore}>
        <div> 
           <ReduxToastr
          timeOut={5000}
          newestOnTop={false}
          preventDuplicates
          position="top-center"
          transitionIn="bounceIn"
          transitionOut="bounceOut"
          progressBar
        /> 
            <Routes />
         </div> 
      </Provider>
		);
	}
}

export default App;
